



























































import { Component, Mixins } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { ExternalWallet, CopyToClipboard, AuthQuery } from '~/mixins';
import { IWallet } from '~/store/inventory/types';
import ConnectWeb3Wallet from '~/components/Wallet/ConnectWeb3Wallet.vue';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import LinkedAccountCard from '~/components/UIComponents/LinkedAccountCard.vue';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({
  components: {
    ConnectWeb3Wallet,
    TwoFactorAuthInputPrompt,
    LinkedAccountCard,
  },
})
export default class Web3WalletConnections extends Mixins(
  ExternalWallet,
  CopyToClipboard,
  AuthQuery,
) {
  @State(profile => profile.user.walletExists, { namespace: 'profile' })
  walletExists!: boolean;
  @State(inventory => inventory.wallets, { namespace: 'inventory' })
  wallets!: IWallet[];
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;

  @Action('disconnectWalletFromUser', { namespace: 'web3Wallet' })
  private disconnectWalletFromUser!: (args: {
    twoFaWrapper: <TReturnType>(
      queryDelegate: (twoFaPin: string) => Promise<TReturnType>,
      twoFaCheckpoint?: TwoFaCheckpoint,
    ) => Promise<TReturnType>;
  }) => {
    success: boolean;
    message?: string;
  };

  galaWalletIcon = require('@/assets/logos/GALA-icon.png');
  isConnecting = false;
  isDisconnecting = false;
  showInstructions = false;

  get hasWallet() {
    return this.walletConnected || this.walletExists;
  }

  get connectionStatus() {
    return this.linkedWallet && this.linkedWallet.hasBrowswerConnection
      ? this.$t('components.settings.LinkedAccounts.connected')
      : this.$t('components.settings.LinkedAccounts.disconnectedFromBrowser');
  }

  get linkedWallet() {
    if (this.walletConnected && this.connectedExternalWallet.ethAddress) {
      const providerDetails = this.providerOptions.find(
        option => option.label === this.connectedExternalWallet.walletProvider,
      );
      const hasBrowswerConnection =
        this.connectedExternalWallet.ethAddress ===
        this.connectedWallet.address;
      return {
        address: this.connectedExternalWallet.ethAddress,
        label: providerDetails?.label,
        icon: providerDetails?.icon,
        external: true,
        hasBrowswerConnection,
      };
    }

    const ethWallet = this.wallets.find(
      wallet => wallet.network === 'ETHEREUM',
    );
    const ethAddress = ethWallet?.receiveAddress
      ? ethWallet.receiveAddress.trim()
      : '';

    if (ethWallet && ethAddress && this.walletExists) {
      return {
        address: ethAddress,
        label: `GALA ${this.$t(
          'components.settings.web3WalletConnections.wallet',
        )}`,
        icon: this.galaWalletIcon,
        external: false,
        hasBrowswerConnection: true,
      };
    } else {
      return {
        address: '',
        label: '',
        icon: '',
        external: false,
        hasBrowswerConnection: false,
      };
    }
  }

  truncateAddress(address: string) {
    const charCount = this.$vuetify.breakpoint.mdAndDown ? 6 : 18;

    const string = `${address.slice(0, charCount)}....${address.substr(
      address.length - 4,
      address.length,
    )}`;

    return string;
  }

  async handleDisconnect() {
    // we can only 'disconnect' the wallet in our db. The user would need to manually disconnect from extension to remove browser connection.
    // should we make this clear to the user? ^^

    this.isDisconnecting = true;
    const { success, message } = await this.disconnectWalletFromUser({
      twoFaWrapper: this.doAuthQuery,
    });
    this.isDisconnecting = false;
    if (!success) {
      this.isDisconnecting = false;
      this.updateSnackbarErrorText(message);
      this.toggleErrorSnackbar();
    }
  }

  showConnectionInstructions() {
    this.showInstructions = true;
  }
}
